/* eslint-disable max-lines */

export const config = {
    name: 'submissionApplication54512313',
    selection: false,
    index: false,
    searchFields: [
        {
            name: '年份',
            value: 'applyYear',
            isFixed: true,
            type: 'date',
            timeType: 'year',
            format: 'yyyy',
            valueFormat: 'yyyy',
            span: 4
        },
        {
            name: '标题',
            value: 'applyTitle',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '目标类型',
            value: 'goalTypeName',
            type: 'advanceMulti',
            isFixed: true,
            span: 4,
            advanceConfig: [
                { prop: 'goalTypeName', value: '目标类型' },
                { prop: 'goalTypeCode', value: '目标类型编码' }
            ],
            tableConfig: [
                { prop: 'goalTypeCode', value: '目标类型编码' },
                { prop: 'goalTypeName', value: '目标类型', 'displayName': 'goalTypeName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/goalType/page',
            cbParams: ['goalTypeCode', 'goalTypeName']
        },
        {
            name: '部门',
            prop: 'deptName',
            value: 'deptName',
            type: 'advance',
            isFixed: true,
            span: 4,
            advanceConfig: [
                { 'prop': 'deptName', 'value': '部门名称' },
                { 'prop': 'deptCode', 'value': '部门编码' }
            ],
            tableConfig: [
                { 'prop': 'deptCode', 'value': '部门编码' },
                { 'prop': 'deptName', 'value': '部门名称', 'displayName': 'deptName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/goal/manage/dept/page',
            cbParams: ['deptCode', 'deptName'],
            advanceCode: 'advanceCode'
        }
    ],
    columns: [
        {
            label: '申请单号',
            prop: 'applyCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 130
        },

        {
            label: '标题',
            prop: 'applyTitle',
            width: 180
        },
        {
            label: '年份',
            prop: 'applyYear',
            width: 60
        },
        {
            label: '部门',
            prop: 'deptName',
            width: 160
        },
        {
            label: '目标类型',
            prop: 'goalTypeNames',
            width: 160
        },
        {
            label: '审批状态',
            prop: 'approvalStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LCRM_MIP_STATUS', // TODO
            width: 80
        },
        {
            label: '备注',
            prop: 'mark',
            width: 120
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: 80
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 160
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            width: 80
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 160
        }
    ]
};
